<template>
    <Modal
        v-model="visible"
        width="1000px"
        title="新增业务员"
        :footer-hide="true"
        :mask-closable="false"
        class="train-add-user my-modal p-b"
    >
        <div class="top-box">
            <Input v-model="searchParams.nameOrNo" placeholder="请输入员工名称或工号" search @on-search="searchAjax()" />
            <Button type="primary" @click="submit">确定</Button>
        </div>
        <orgTree @change="selectNode" isSelect="1" ref="treeBox" :isAll="true" :multiple="false"></orgTree>
        <div class="table-box">
            <loading :isShow="listLoading" />
            <Table :columns="columns" :data="tableData" @on-select-all="tableSelect" @on-select="tableSelect" :maxHeight="tableH">
                <template slot-scope="{ row }" slot="name">
                    <div class="dian"></div>
                    {{ row.name }}
                </template>
                <template slot-scope="{ row }" slot="action">
                    <div class="detail">
                        <div @click="del(row)">
                            <span>删除</span>
                        </div>
                    </div>
                </template>
            </Table>
        </div>
    </Modal>
</template>

<script>
import orgTree from '@/components/commons/orgTree/orgTree';
import { pageTool } from '@/api/mixins';
export default {
    components: {
        orgTree
    },
    props: [],
    mixins: [pageTool],
    data() {
        return {
            visible: false,
            loading: false,
            formData: {},
            tableH: document.body.clientHeight - 260,
            tableSelectData: [],
            columns: [
                {
                    type: 'selection',
                    width: 50,
                    align: 'center'
                },
                {
                    title: '工号',
                    key: 'staffNo',
                    align: 'center'
                },
                {
                    title: '姓名',
                    slot: 'name',
                    align: 'center'
                },
                {
                    title: '所属机构',
                    key: 'organizationName',
                    align: 'center'
                },
                {
                    title: '所属团队',
                    key: 'groupName',
                    align: 'center'
                }
            ]
        };
    },
    created(){
        window.addEventListener("resize", ()=>{
            this.tableH = document.body.clientHeight - 260
        });
    },
    methods: {
        open(data = {}) {
            this.formData.trainId = data.id;
            this.searchParams.trainId = data.id;
            this.visible = true;
            this.listUrl = '/buz/userBase/queryTrainList';
            this.pageNum = 1;
            this.pageSize = 999;
            this.getList();
            this.$refs.treeBox.init('', { source: '2' });
        },

        // 列表选择
        tableSelect(selection, row) {
            console.log(selection, row);
            this.tableSelectData = selection;
        },
        // 选择组织
        selectNode(cur) {
            this.searchParams.nameOrNo = '';
            if (cur.nodeType === 1) {
                //机构
                this.searchParams.organizationId = cur.id;
                this.searchParams.groupId = '';
            } else {
                this.searchParams.organizationId = '';
                this.searchParams.groupId = cur.id;
            }
            if (!this.visible) {
                //不显示时不处理
                return;
            }
            this.searchAjax();
        },

        listCallback(res) {
            res.data.forEach(item => {
                if (item.isChoose) {
                    item._disabled = false;
                } else {
                    item._disabled = true;
                }
            });
        },

        submit() {
            console.log('validate');
            if (this.loading) {
                return;
            }
            this.formData.users = this.tableSelectData.map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    code: item.code
                };
            });
            if (this.formData.users.length == 0) {
                this.$notice.msg('请选择需要添加的业务员');
                return;
            }
            this.listLoading = true;
            this.$http({
                type: 'POST',
                url: '/buz/userTrain/batchTrain',
                data: this.formData
            })
                .then(res => {
                    this.$notice.success('提交成功');
                    this.$emit('suceess');
                    this.getList();
                })
                .catch(res => {
                    this.listLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.train-add-user /deep/ {
    .dian {
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        width: 5px;
        height: 5px;
        background: #35bf3f;
        border-radius: 50%;
        margin-right: 4px;
        &.red {
            background: #e3461f;
        }
    }
    .ivu-modal {
        top: 5vh;
    }
    .ivu-modal-body {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        .top-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            .ivu-input-wrapper {
                width: 300px;
            }
        }
        .org-tree-panel {
            padding: 0;
            height: calc(90vh - 160px);
            margin-top: 10px;
        }
        .table-box {
            width: calc(100% - 320px);

            margin-top: 10px;
            .ivu-table-body {
                &:before {
                    content: '';
                    position: absolute;
                    background-color: #dcdee2;
                    width: 100%;
                    height: 1px;
                    left: 0;
                    bottom: 0;
                    z-index: 4;
                }
                &::-webkit-scrollbar-track {
                    border-right: 1px solid #e9e9e9;
                    border-left: 1px solid #e9e9e9;
                    border-bottom: 1px solid #e9e9e9;
                }
            }
        }
    }
}
</style>
